export default __webpack_public_path__ + "static/media/banking.35b1eafb.png";